import { Injectable } from '@angular/core';
import { ChainSenders } from './chain.interface';
import { BaseChainValidator } from './base-chian-validator';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';

@Injectable({
  providedIn: 'root'
})
export class ChainResponsibilityService {
  private readonly chain: BaseChainValidator;
  constructor() {
    this.chain = new BaseChainValidator();
  }

  public async handleClickEvent(sender: ChainSenders, feature: AsgardFeatureNames | null = null, documentId: string | null = null,
                                paneIndex: number | null = null, event: any, clickHandler: (...args) => void, args: any): Promise<void> {
                                  // console.warn('sender: ', sender, 'feature: ', feature, paneIndex)
    const validationResult = await this.chain.validate(sender, feature, documentId, paneIndex, event, args);
    if (validationResult && clickHandler) {
      if (args && args instanceof Array) {
        clickHandler(...args);
      } else if (args) {
        clickHandler(args);
      } else {
        clickHandler();
      }
    }
  }
}
